import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { testTypesProvider } from '../../../../data/providers/testTypesProvider';
import { toOptions } from '../../../../data/providers/utils/toOptions';
import { ISelectableEntity, ISelectableTestType } from '../../../../data/types';
import { Select } from '../Select';

interface IProps {
  value: ISelectableTestType | ISelectableTestType[];
  disabled: boolean;
  onChange: (s: ISelectableTestType | ISelectableTestType[]) => void;
  style?: React.CSSProperties;
  allowMultiple?: boolean;
  id?: string;
}
const TestTypeSelect = (props: IProps): React.ReactElement => {
  const [options, setOptions] = React.useState<ISelectableEntity[]>();

  /**
   * @description subscribes to test types and converts them to options
   */
  React.useEffect((): (() => void) => {
    const subscriber = testTypesProvider()
      .pipe(toOptions)
      .subscribe((mOptions: ISelectableTestType[]): void => {
        setOptions(mOptions);
      });
    return (): void => {
      subscriber.unsubscribe();
    };
  }, []);

  /**
   * @description handles change to selected test type
   * @param s
   * @returns
   */
  const handleOnChange = (
    s: ISelectableTestType | ISelectableTestType[]
  ): void => props.onChange(s);

  return (
    <React.Fragment>
      <Select
        aria-label='test type selector'
        options={options}
        value={isEmpty(props.value) ? null : props.value}
        placeholder='Test Type...'
        isDisabled={props.disabled}
        onChange={handleOnChange}
        inputId={props.id ?? 'test-type-select'}
        isMulti={props.allowMultiple}
      />
    </React.Fragment>
  );
};

export { TestTypeSelect };
